// extracted by mini-css-extract-plugin
export default {"container":"styles_container__J3ByT","title":"styles_title__Xjh7+"};